import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from 'config';
import MainLogo from '../../../assets/images/NewCarton.svg';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    // <Link component={RouterLink} to={DASHBOARD_PATH}>
    <Link component={RouterLink} to="/">
        {' '}
        <img src={MainLogo} alt="CartonLogo" width="100%" height="100%" className="sidebar-logo" />
    </Link>
);

export default LogoSection;
